import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isChangePlanzoneLogoRequestFailure() {
      return getState().isFailure;
    },
    isChangePlanzoneLogoRequestPending() {
      return getState().isPending;
    },
    isChangePlanzoneLogoRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
